import Settings from 'Settings'

const defaultHeaders = {
  'X-API-KEY': `${Settings.get('REACT_APP_RAA_KEY')}`
}

export default defaultHeaders
